// extracted by mini-css-extract-plugin
export default {"wrapper":"styles__wrapper___MwLon","header":"styles__header___AAcJh","headerTitle":"styles__headerTitle___wpIJ5","createNewButton":"styles__createNewButton___GSu6s"};